import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class HmCoverageService {
    private smCoverage: any;
    private amCoverage: any;
    private smErrorCoverage: any;
    private amErrorCoverage: any;

    constructor() {
        this.smCoverage = new BehaviorSubject<boolean>(null);
        this.smErrorCoverage = new BehaviorSubject<boolean>(null);
        this.amCoverage = new BehaviorSubject<any>(null);
    }

    setSmCoverage(data) {
        this.smCoverage.next(data);
    }

    getSmCoverage() {
        return this.smCoverage.asObservable();
    }

    setSmErrorCoverage(data) {
        this.smErrorCoverage.next(data);
    }

    getSmErrorCoverage() {
        return this.smErrorCoverage.asObservable();
    }

    setAmCoverage(data) {
        this.amCoverage.next(data);
    }

    getAmCoverage() {
        return this.amCoverage.asObservable();
    }

    setAmErrorCoverage(data) {
        this.amErrorCoverage.next(data);
    }

    getAmErrorCoverage() {
        return this.amErrorCoverage.asObservable();
    }
}
